export const constants = {
    NULL_ADDRESS: '0x0000000000000000000000000000000000000000',
    TESTRPC_NETWORK_ID: 50,
    MAX_DIGITS_IN_UNSIGNED_256_INT: 78,
    INVALID_JUMP_PATTERN: 'invalid JUMP at',
    OUT_OF_GAS_PATTERN: 'out of gas',
};



// WEBPACK FOOTER //
// ./~/0x.js/src/utils/constants.ts